import { Breadcrumbs, DropDownMenu, FlashMessage, GlobalLoader, InputField, Modal } from '@reactiveonline/reactive_admin_shared-packages'
import React, { useRef, useState } from 'react'
import GlobalImports from '../shared/GlobalImports'

export default function Show({
  appProps, administrator, breadcrumbs, canChangePassword, icon, updatePasswordPath
}) {
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [existingPassword, setExistingPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [newPasswordConfirmation, setNewPasswordConfirmation] = useState('')
  const [passwordValidator, setPasswordValidator] = useState({})
  const [passwordShown, setPasswordShown] = useState({
    existing: false,
    new: false,
    confirmation: false
  })

  const flashMessageRef = useRef(null)

  const dropdownActions = []

  if (canChangePassword) {
    dropdownActions.push({
      icon: 'fa-key',
      action: () => setShowChangePasswordModal(true),
      text: Support.translations.administrator.change_password,
      permissions: canChangePassword
    })
  }

  const disableSave = !(passwordValidator.length && passwordValidator.number && passwordValidator.uppercase && passwordValidator.lowercase)
  const unmatchedPasswords = (newPassword != newPasswordConfirmation)

  const closeChangePasswordModal = () => {
    setExistingPassword('')
    setNewPassword('')
    setNewPasswordConfirmation('')
    setShowChangePasswordModal(false)
  }

  const handlePassword = event => {
    const value = event.target.value
    let validations = {}

    if (value.length >= 8) {
      validations = { ...validations, length: true }
    }
    if (value.match(/^.*\d.*$/)) {
      validations = { ...validations, number: true }
    }
    if (value.match(/^.*[A-Z].*$/)) {
      validations = { ...validations, uppercase: true }
    }
    if (value.match(/^.*[a-z].*$/)) {
      validations = { ...validations, lowercase: true }
    }

    setPasswordValidator(validations)
    setNewPassword(value)
  }

  const handleSave = _event => {
    if (existingPassword.length === 0) {
      flashMessageRef.current.show(Support.translations.administrator.attributes.no_current_pass, 'error')
    } else if (newPassword.length === 0 && newPasswordConfirmation.length === 0) {
      flashMessageRef.current.show(Support.translations.administrator.attributes.no_pass_set, 'error')
    } else if (disableSave) {
      flashMessageRef.current.show(Support.translations.administrator.attributes.validation_not_passed, 'error')
    } else if (unmatchedPasswords) {
      flashMessageRef.current.show(Support.translations.administrator.attributes.password_unmatched, 'error')
    } else {
      save()
    }
  }

  const save = () => {
    const fd = new FormData()

    fd.append('old_password', existingPassword)
    fd.append('new_password', newPassword)
    fd.append('password_confirmation', newPasswordConfirmation)

    setLoading(true)

    Rails.ajax({
      type: 'PATCH',
      url: updatePasswordPath,
      dataType: 'json',
      data: fd,
      success: res => {
        flashMessageRef.current.show(res.message)
        closeChangePasswordModal()
        window.location.href = res.redirectUrl
      },
      error: res => {
        setLoading(false)
        flashMessageRef.current.show(res.error, 'error')
      }
    })
  }

  return (
    <>
      <div className='page-wrapper-header'>
        <div style={{ width: '100%' }}>
          <div className='flex-box items-center content-space-between'>
            <div className='page-header'>
              <i className={ `fa-light ${ icon }` }/>
              <h1 className='page-header-title'>
                { administrator.email }
              </h1>
            </div>

            { dropdownActions.length > 0 &&
              <DropDownMenu
                items={ dropdownActions }
                title={ ReactiveCore.translations.dropMenuAction }
              />
            }
          </div>

          <Breadcrumbs
            breadcrumbs={ breadcrumbs }
            wrapperHeader={ false }
          />
        </div>
      </div>

      <div className='card'>
        <div className='card-content'>
          <div className='card-title m-b-20'>
            { Support.translations.administrator.account_information }
          </div>

          <div className='card-body'>
            <div className='flex-box flex-column'>
              <div
                className='flex-box items-center content-space-between'
                style={{ padding: '20px 0', borderBottom: '1px solid #ddd' }}
              >
                <div>{ Support.translations.user.name }</div>
                <div>{ administrator.name || '-' }</div>
              </div>

              <div
                className='flex-box items-center content-space-between'
                style={{ padding: '20px 0', borderBottom: '1px solid #ddd' }}
              >
                <div>{ Support.translations.administrator.attributes.email }</div>
                <div>{ administrator.email }</div>
              </div>

              <div
                className='flex-box items-center content-space-between'
                style={{ padding: '20px 0', borderBottom: '1px solid #ddd' }}
              >
                <div>{ Support.translations.user.uid }</div>
                <div>{ administrator.uid || '-' }</div>
              </div>

              <div
                className='flex-box items-center content-space-between'
                style={{ padding: '20px 0', borderBottom: '1px solid #ddd' }}
              >
                <div>{ Support.translations.role.model_name }</div>
                <div>{ administrator.roleTitle }</div>
              </div>

              { !!administrator.invitedBy &&
                <div
                  className='flex-box items-center content-space-between'
                  style={{ padding: '20px 0', borderBottom: '1px solid #ddd' }}
                >
                  <div>{ Support.translations.administrator.invited_by }</div>
                  <div>{ administrator.invitedBy }</div>
                </div>
              }

              <div
                className='flex-box items-center content-space-between'
                style={{ padding: '20px 0', borderBottom: '1px solid #ddd' }}
              >
                <div>{ Support.translations.administrator.attributes.sign_in_count }</div>
                <div>{ administrator.signInCount }</div>
              </div>

              { !!administrator.lastSignInAt &&
                <div
                  className='flex-box items-center content-space-between'
                  style={{ padding: '20px 0', borderBottom: '1px solid #ddd' }}
                >
                  <div>{ Support.translations.administrator.attributes.last_sign_in_at }</div>
                  <div>{ administrator.lastSignInAt }</div>
                </div>
              }

            </div>
          </div>
        </div>
      </div>

      { showChangePasswordModal &&
        <Modal
          visible={ showChangePasswordModal }
          closeModal={ closeChangePasswordModal }
          mode='large'
          showConfirmation
          confirmationText={ Support.translations.administrator.change_password_confirmation }
          action={ handleSave }
          actionText={ ReactiveCore.translations.confirm }
          disableAction={ disableSave || unmatchedPasswords || existingPassword.length === 0 }
        >
          <div className='bold' style={{ fontSize: 32 }}>
            { Support.translations.administrator.change_password }
          </div>

          <div className='form m-t-20'>
            <div className='field' style={{ position: 'relative' }}>
              <InputField
                className='input-field'
                style={{ position: 'relative' }}
                label={ Support.translations.administrator.attributes.current_password }
              >
                <input
                  type={ passwordShown.existing ? "text" : "password" }
                  value={ existingPassword }
                  onChange={ e => setExistingPassword(e.target.value) }
                />
              </InputField>
              { existingPassword.length > 0 &&
                <div style={{ position: 'absolute', right: '15px', top: '30px', fontSize: '14px' }}>
                  <i
                  className={ `pointer fa-light ${ passwordShown.existing ? 'fa-eye-slash' : 'fa-eye' }` }
                  onClick={ () => setPasswordShown(prevState => ({ ...prevState, existing: !prevState.existing })) } />
                </div>
              }
            </div>

            <div className='field' style={{ position: 'relative' }}>
              <InputField
                className='input-field'
                style={{ position: 'relative' }}
                label={ Support.translations.administrator.attributes.new_password }
              >
                <input
                  type={ passwordShown.new ? "text" : "password" }
                  value={ newPassword }
                  onChange={ handlePassword }
                />
              </InputField>
              { newPassword.length > 0 &&
                <div style={{ position: 'absolute', right: '15px', top: '30px', fontSize: '14px' }}>
                  <i
                  className={ `pointer fa-light ${ passwordShown.new ? 'fa-eye-slash' : 'fa-eye' }` }
                  onClick={ () => setPasswordShown(prevState => ({ ...prevState, new: !prevState.new })) } />
                </div>
              }
            </div>

            <div className='field' style={{ position: 'relative' }}>
              <InputField
                className='input-field'
                style={{ position: 'relative' }}
                label={ Support.translations.administrator.attributes.password_confirmation }
              >
                <input
                  type={ passwordShown.confirmation ? "text" : "password" }
                  value={ newPasswordConfirmation }
                  onChange={ e => setNewPasswordConfirmation(e.target.value) }
                />
              </InputField>
              { newPasswordConfirmation.length > 0 &&
                <div style={{ position: 'absolute', right: '15px', top: '30px', fontSize: '14px' }}>
                  <i
                  className={ `pointer fa-light ${ passwordShown.confirmation ? 'fa-eye-slash' : 'fa-eye' }` }
                  onClick={ () => setPasswordShown(prevState => ({ ...prevState, confirmation: !prevState.confirmation })) } />
                </div>
              }
            </div>

            <div className='field flex-box flex-wrap items-center content-space-between'>
              <div
                className={`pass-validator ${ passwordValidator.length ? '' : 'invalid' } `}
              >
                { Support.translations.administrator.attributes.password_length }
              </div>
              <div
                className={`pass-validator pass-validator-right ${ passwordValidator.number ? '' : 'invalid' } `}
              >
                { Support.translations.administrator.attributes.password_number }
              </div>
              <div
                className={`pass-validator ${ passwordValidator.uppercase ? '' : 'invalid' } `}
              >
                { Support.translations.administrator.attributes.password_uppercase }
              </div>
              <div
                className={`pass-validator pass-validator-right ${ passwordValidator.lowercase ? '' : 'invalid' } `}
              >
                { Support.translations.administrator.attributes.password_lowercase }
              </div>
            </div>
          </div>

          { loading && <GlobalLoader fullPage /> }
        </Modal>
      }

      { loading && <GlobalLoader fullPage /> }

      <FlashMessage ref={ flashMessageRef } />
      <GlobalImports appProps={ appProps } />
    </>
  )
}